(() => {
  const run = () => {
    document.querySelectorAll('.mh2-cart').forEach((cart) => {
      if (cart.dataset.mh2IconReady === 'true') return;
      const label = cart.textContent.trim();
      cart.dataset.mh2IconReady = 'true';
      cart.setAttribute('aria-label', label);
      cart.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9h16l-1.5 10h-13L4 9Z"/><path d="m8 9 2-5m4 0 2 5M8 13h8m-7 0v3m3-3v3m3-3v3"/></svg>';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
})();
